<template>

    <div v-if="questions.length" class="accordion" id="questionAccordion">
        <!--fixa template för loopen-->
<template v-for="q, i in questions" :key="i">
        <div class="accordion-item" v-if="q.content.rendered" >
           
            <strong class="accordion-header" :id="'heading'+ q.id">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    :data-bs-target="'#collapse-' + q.id" aria-expanded="false" :aria-controls="'collapse-' + q.id"
                    v-html="q.title.rendered">
                </button>
            </strong>
            <div :id="'collapse-' + q.id" class="accordion-collapse collapse"
               :aria-labelledby="'heading' + q.id"
                data-bs-parent="#questionAccordion">
                <div class="accordion-body"><span v-html="q.content.rendered"></span>
                    <a
                    v-if="q.acf.call_to_action.length != 0"
                    class="btn btn-primary mb-2"
                    style="
                    white-space:normal !important;"
                    target="_blank"
                    :href="q.acf.call_to_action_link"
                    >{{ q.acf.call_to_action }}</a>
                </div>
            </div>
        </div>
        </template>
    </div>
</template>

<script>

export default {
    props: { singleq: { type: String } },
    data() {
        let questions = [];
        let singleQ = this.singleq.split(',')

        
        
        return {
            questions,
            singleQ
        }


    },

    methods:{

        fetchQuestions(q){
            fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?type=single&include=" + q)
            .then(res => res.json())
            .then(json => { this.questions = json})
            
            
            
            


            
        }
    },
    mounted(){

            this.fetchQuestions(this.singleq)
      
    }
}


</script>